module.exports = __webpack_public_path__ + "img/Onion.712b930b.svg";